"use client";

import { useEffect } from 'react';
import { useNavigation } from '@/app/hooks/useNavigation';
import AOS from 'aos';
import 'aos/dist/aos.css';

interface BannerData {
  discount: string;
  title: string;
  date: string;
  image: string;
  title2: string;
  title3: string;
  title4: string;
  bgColor: string;
  website: string;
  ctaText: string
}

const BannerTemplate = ({ data }: { data: BannerData }) => {
  const { handleNavigation } = useNavigation();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-sine',
      delay: 100,
      offset: 100,
    });
    AOS.refresh();
  }, []);



  return (
    <div className="min-h-[550px] flex justify-center items-center p-5">
      <div className="container">
        <div
          style={{ backgroundColor: data.bgColor }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center text-white rounded-3xl"
        >
          {/* First Column */}
          <div className="p-6 sm:p-8">
            <p data-aos="slide-right" className="text-sm">
              {data.discount}
            </p>
            <h1
              data-aos="zoom-out"
              className="uppercase text-4xl lg:text-7xl font-bold"
            >
              {data.title}
            </h1>
            <p data-aos="fade-up" className="text-sm">
              {data.date}
            </p>
          </div>
          <div data-aos="zoom-in" className="h-full flex items-center">
            <img
              src={data.image}
              alt="Promotional product"
              className="scale-125 w-[250px] md:w-[340px] mx-auto drop-shadow-[-10px_10px_12px_rgba(0,0,0,.6)] object-cover"
            />
          </div>
          {/* Third Column */}
          <div className="flex flex-col justify-center gap-4 p-6 sm:p-8">
            <p data-aos="zoom-out" className="font-bold text-xl">
              {data.title2}
            </p>
            <p data-aos="fade-up" className=" text-3xl sm:text-5xl font-bold">
              {data.title3}
            </p>
            <p data-aos="fade-up" className="text-sm tracking-wide leading-5">
              {data.title4}
            </p>
            <div data-aos="fade-up" data-aos-offset="0">
              <button
                onClick={() => handleNavigation(data.website)}
                style={{ color: data.bgColor }}
                className="bg-white py-2 px-4 rounded-full"
              >
                {data.ctaText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerTemplate